import { render, staticRenderFns } from "./SmeBadge.vue?vue&type=template&id=5facf6df&scoped=true&"
import script from "./SmeBadge.vue?vue&type=script&setup=true&lang=js&"
export * from "./SmeBadge.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SmeBadge.vue?vue&type=style&index=0&id=5facf6df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5facf6df",
  null
  
)

export default component.exports